/**
 * @file StatisticConst.js
 * @desc 统计日志埋点静态文件
 * @author ~~
 * @data 2020/4/22
 */
import statisticAction from '@/common/utils/statisticAction';
const statisticConst = {};
const sendBaiduStatistics = statisticAction.sendBaiduStatistics;
// const sendStatisticalInfo = statisticAction.submitStatisticalInfo;

// 首页展现来源
statisticConst.homeFrom = from => {
    sendBaiduStatistics('homeShow', 'from', from);
};

// 红包按钮点击
statisticConst.couponClick = type => {
    sendBaiduStatistics('couponClick', 'click', type);
};

// 分享按钮点击
statisticConst.shareBtnClick = () => {
    sendBaiduStatistics('shareBtnClick', 'click');
};

// 规则按钮点击
statisticConst.ruleBtnClick = () => {
    sendBaiduStatistics('ruleBtnClick', 'click');
};

// 奖品按钮点击
statisticConst.prizeBtnClick = () => {
    sendBaiduStatistics('prizeBtnClick', 'click');
};

// 立即打车点击
statisticConst.dacheBtnClick = () => {
    sendBaiduStatistics('dacheBtnClick', 'click');
};

// 登录点击
statisticConst. jumpLogin = () => {
    sendBaiduStatistics('jumpLogin', 'click');
};


export default statisticConst;
